import { useViewport } from "@faire/web/ui/hooks/useViewport";
import * as React from "react";

export interface IViewportV2Props {
  viewport: ReturnType<typeof useViewport>;
}

/**
 * HOC alternative to ui/hooks/useViewport
 * @param Component The component to enhance.
 * @deprecated use `useViewport` instead
 */
export const withViewportV2 = <T extends IViewportV2Props>(
  Component: React.ComponentType<T>
) =>
  React.forwardRef(
    (props: Omit<React.PropsWithChildren<T>, "viewport">, ref) => {
      const viewport = useViewport();
      return <Component {...(props as T)} ref={ref} viewport={viewport} />;
    }
  );
